import { lazy } from 'react';
import { Zap, Users, FileText } from 'lucide-react';
import { defineFrontendModule } from '../../core/modules/types';
import { registerWallboxWidgets } from './widgets';

export default defineFrontendModule({
  id: 'wallbox',
  name: 'Wallbox',

  routes: [
    { path: 'wallbox/charges', menuKey: 'wallbox.charges', element: lazy(() => import('./pages/Charges')) },
    { path: 'wallbox/users', menuKey: 'wallbox.users', element: lazy(() => import('./pages/Users')) },
    { path: 'wallbox/invoices', menuKey: 'wallbox.invoices', element: lazy(() => import('./pages/Invoices')) },
  ],

  nav: [
    {
      menuKey: 'wallbox',
      defaultIcon: Zap,
      items: [
        { menuKey: 'wallbox.charges', path: '/wallbox/charges', label: 'Ladevorgänge', icon: Zap },
        { menuKey: 'wallbox.users', path: '/wallbox/users', label: 'Benutzer', icon: Users },
        { menuKey: 'wallbox.invoices', path: '/wallbox/invoices', label: 'Rechnungen', icon: FileText },
      ],
    },
  ],

  registerWidgets: registerWallboxWidgets,
});
